<template>
  <div v-if="itemid">
    <h3 style="margin-top: 30px">Bank Verification Completed</h3>
    <p>
      Congrats! You verified your bank account. We are now getting your offers ready.
    </p>
    <div class="buttons is-right">
      <a
        class="button is-link padded-button next-button is-loading"
        @click="next"
        >Continue</a
      >
    </div>
  </div>
  <div v-else>
    <div v-if="offers" style="margin: 0 auto; max-width: 360px; ">
      <div id="pre-offers-container">
        <div id="gif-container">
          <div id="circle-container">
            <img src="https://cardiff.b-cdn.net/img/prequalified-icon.svg" width="81px" height="81px" alt="Loading animation">
          </div>
        </div>
        <h2 style="margin-top: -25px" id="congratulations-title">Congratulations!</h2>
        <p class="label" style="text-align: center;" id="pre-qualify-label"> You're Pre-Qualified </p>
        <List
          :inputField="inputs.pre_offers"
          inputName="Select from eligible offers"
          :options="offers"
          inputId="offers"
          :fullWidthOption="true"
          ref="pre_offers"
        />
        <div id="need_other_amount_container">
          <Input
            :inputField="inputs.pre_offer_another_amount"
            inputName="Need another amount?"
            inputType="string_empty"
            :icons="{ left: 'fa-dollar-sign' }"
            ref="pre_offer_another_amount"
          />
        </div>
        <div id="error_display">
          There was an error
        </div>
      </div>
      <div class="buttons is-right" id="continue-prequalified-container">
        <a
          class="button is-link padded-button next-button"
          @click="next"
          id="continue-prequalified-button"
          >Continue</a
        >
      </div>
    </div>
    <div v-else>
      <h3 style="margin-top: 30px; text-align: center;">Loading..</h3>
      <p style="text-align: center;">
        Looking for Offers
      </p>
    </div>
  </div>
</template>

<script>
import Input from "@/components/shared/Input";
import List from "@/components/shared/List";
import ApplyPage from "@/components/shared/ApplyPage";
import MyUtils from "@/utils/MyUtils";

import $ from "jquery";


function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

function getDeviceType() {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  if (
    /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return "mobile";
  }
  return "desktop";
}

export default {
  name: "PlaidResult",
  components: {
    List,
    Input
  },
  mixins: [ApplyPage],
  props: {
    itemid: String,
    api: String,
    link: String,
  },
  data() {
    return {
      obj: "financials",
      inputs: {
        ts: "",
        pre_offers: Input.model(),
        pre_offer_another_amount: Input.model()
      },
      monthOptions: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      attached: false,
      clicked: false,
      ready: false,
      fileList: [],
      device_type: "",
      offers : null,
      max_offer_amount: 0
    };
  },
  created: function(){
    console.log('created',new Date().toLocaleString());
  },
  mounted: function () {
    console.log('mounted', new Date().toLocaleString());
    var self = this;
    this.device_type = getDeviceType();
    // setTimeout()
    if (self.itemid) {
      setTimeout(this.next, 5000);
      setTimeout(function () {
        var ecData = {
          email: getWithExpiry("email"),
          phone_number: getWithExpiry("phone_number"),
          address: {
            first_name: getWithExpiry("first_name"),
            last_name: getWithExpiry("last_name"),
            street: getWithExpiry("street"),
            city: getWithExpiry("city"),
            region: getWithExpiry("state"),
            postal_code: getWithExpiry("postal_code"),
            country: "us",
          },
        };
        let monthly_sales = getWithExpiry("monthly_sales");
        let monthly_sales_float = 0;
        if (monthly_sales && typeof monthly_sales ==='string' && monthly_sales != "") {
          monthly_sales_float = parseFloat(monthly_sales.replace(/,/g, ""));
        } else if (monthly_sales && typeof monthly_sales ==='number' && monthly_sales != "") {
          monthly_sales_float = monthly_sales;
        }
        self.$gtm.trackEvent({
          event: "complete_app",
          ecData: ecData,
          // category: 'Contact Form',
          // action: 'click',
          // label: 'Contact Form Complete',
          value: monthly_sales_float,
        });
        fbq("track", "SubmitApplication");
      }, 2000);
    }else{
      // pull offers from backend
      $.ajax({
        type: "POST",
        url: "/api/lead/pre-offers",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({
          sf_leadid: self.link,
        }),
      })
      .done(function (response) {
        console.log("response offer_status", response);
        if(response.valid === false){
          self.next(true);
        }
        if(response.offers && response.offers.length > 0){
          console.log(response.offers);
          self.max_offer_amount = response.offers[0];
          // self.offers = response.offers;
          self.offers = response.offers.map(value => `$${Number(value).toLocaleString('en-US')}`);
          // $('.option_container').addClass('list-full-option');
          setTimeout(function(){
            self.confetti(); 
            $('input[name="offers"]').click(function(e){
              // self.offer_selected($(this).val());
              self.$refs.pre_offer_another_amount.setValue('');
              // self.pre_offer_another_amount.value = '';
            });
            $('input[name="offers"]:first').trigger('click');
            // $('.option_container').addClass('list-full-option');
            $('.option_container').css("margin-bottom", "8px !important");
            $("#need_other_amount_container .field").addClass('small-input');
            $("#need_other_amount_container .label").css('text-align','center');
            $('#need_other_amount_container .small-input').keyup(function(event){
              self.enterOtherAmount(event);
              // self.formatInput(this);
              
              let current_val = self.inputs.pre_offer_another_amount.value;
              let newval = current_val
              .toString()
              .replace(/\D/g, "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              self.$refs.pre_offer_another_amount.setValue(newval);
              });
          },100);
        }
      })
      .fail(function (err) {
        console.log(err.responseText);
        self.invalid = true;
      });
    }
    // setTimeout(function () {
    //   var fileInput = document.getElementById("file-input");
    //   fileInput.addEventListener("change", function (e) {
    //     // self.fileList = [];
    //     for (var i = 0; i < fileInput.files.length; i++) {
    //       self.fileList.push({
    //         idx: i,
    //         file: fileInput.files[i],
    //         month: Input.model("January"),
    //       });
    //     }
    //     console.log("new filelist", self.fileList);
    //   });
    // }, 2000);
    // $("#transition_container").css("max-width", "100%");
    
  },
  methods: {
    next(moveNext) {
      console.log('validate next');
      self = this;
      if(moveNext === true){
        this.$emit("next", this.$data);
        console.log(this.$data);
      }
      if(self.itemid){
        this.$emit("next", this.$data);
        console.log(this.$data);
      }
      // console.log(self.inputs.pre_offer_another_amount.value)
      // console.log(self.inputs.pre_offers.value)
      
      let selected = self.inputs.pre_offer_another_amount.value;
      let selected_other = self.inputs.pre_offers.value;
      let selected_float = 0;
      let selected_other_float = 0;
      let selected_final = 0;
      if (selected && typeof selected ==='string' && selected != "") {
        selected = selected.replace('$', "");
        selected_float = parseFloat(selected.replace(/,/g, ""));
        selected_final = selected_float;
        console.log('selected_float', selected_float);
      } else if (selected_other && typeof selected_other ==='string' && selected_other != "") {
        selected_other = selected_other.replace('$', "");
        selected_other_float = parseFloat(selected_other.replace(/,/g, ""));
        selected_final = selected_other_float;
        console.log('selected_other_float', selected_other_float);
      }else if(!self.itemid){
        console.log('no selected offer, no item Id')
        return true;
      }
      if(selected_final > self.max_offer_amount ){
        $('#error_display').show().html('Please type a lower amount');
        setTimeout(function(){
          $('#error_display').hide("slow");
        },3000);
        return false;
      }
      if(selected_final <= 0){
        console.log('must select a number bigger than 1');
        $('#error_display').show().text('Please select a valid amount');
        setTimeout(function(){
          $('#error_display').hide("slow");
        },3000);
        return false;
      }
      if(selected_final > 0){
        console.log('found a selected one');
        self.offer_selected(selected_final);
      }

      
    },
    // validate(){
    //   return false;
    //   return true;
    // },
    back() {
      this.$emit("back", this.$data);
      console.log(this.$data);
    },
    humanFileSize(bytes, si = false, dp = 1) {
      const thresh = si ? 1000 : 1024;

      if (Math.abs(bytes) < thresh) {
        return bytes + " B";
      }

      const units = si
        ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
        : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
      let u = -1;
      const r = 10 ** dp;

      do {
        bytes /= thresh;
        ++u;
      } while (
        Math.round(Math.abs(bytes) * r) / r >= thresh &&
        u < units.length - 1
      );

      return bytes.toFixed(dp) + " " + units[u];
    },
    uploadFiles() {
      console.log(this.doc);
      console.log(this.link);
      var self = this;
      if (this.clicked) {
        return;
      }
      if (!$("#file-input").val()) {
        alert("Please upload a valid file.");
        return;
      }
      this.clicked = true;
      var fd = new FormData();

      $.each($("input[type='file']")[0].files, function (i, file) {
        fd.append("file", file);
      });

      // fd.append("file", $('#file-input')[0].files[0])
      self.fileList.forEach((f) => {
        fd.append("fileinfo", JSON.stringify(f));
      });

      fd.append("link", self.link);
      $.ajax({
        type: "POST",
        url: "/api/" + self.api + "/upload-statements",
        contentType: false,
        processData: false,
        data: fd,
      })
      .done(function (resp) {
        self.next(true);
      })
      .fail(function (err) {
        self.clicked = false;
      });
      console.log(fd);
      //upload the file here
    },
    offer_selected(amount_selected){
      let self = this;
      console.log('amount selected', amount_selected);
      MyUtils.setWithExpiry('pre-offer-selected',amount_selected,900000);
      // return false;
      let data = {};
      $.ajax({
        type: "POST",
        url: "/api/lead/pre-offer-selected",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({
          sf_leadid: self.link,
          amount_selected : amount_selected
        }),
      })
        .done(function (resp) {
          MyUtils.setWithExpiry('pre-offer-selected',amount_selected,900000);
          self.back();
        })
        .fail(function (err) {
        });

    },
    confetti() {
      // var animation = lottie.loadAnimation({
      //   container: document.getElementById('circle-container'), // the dom element that will contain the animation
      //   renderer: 'svg',
      //   loop: false,
      //   autoplay: false,
      //   path: '../animations/GreenCheck.json' // the path to the animation json
      // });
      // setTimeout(function() {
      //   animation.play()
      // }, 500);
      for (var i = 0; i < 140; i++) {
        create(i);
      }

      function create(i) {
        var width = Math.random() * 20;
        var height = width * 0.4;
        var colour = "green";

        $('<div class="confetti-' + i + " " + colour + '"></div>')
          .css({
            width: width + "px",
            height: height + "px",
            top: -Math.random() * 20 + "%",
            left: Math.random() * 80 + "%",
            opacity: Math.random() + 0.5,
            transform: "rotate(" + Math.random() * 360 + "deg)"
          })
          .appendTo("#app");
        drop(i);
      }

      function drop(x) {
        $(".confetti-" + x).animate(
          {
            top: "100%",
            left: "+=" + Math.random() * 15 + "%"
          },
          Math.random() * 3000 + 2000,
          function() {
            $(".confetti-" + x).remove();
          }
        );
      }
    },
    enterOtherAmount(event){
      self = this;
      this.$refs.pre_offers.setUIUnselected(null);
    }
  },
};
</script>
<style>
/* custom List option */
#pre-offers-container .list-full-option{
  -webkit-transition: width 2s ease-in-out;
    -moz-transition: width 2s ease-in-out;
    -o-transition: width 2s ease-in-out;
    transition: width 2s ease-in-out;

  width: 100%;
  height: 64px;
}
#pre-offers-container .radio_label{
  color: #28A745;
  text-align: center;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  vertical-align: text-top;
}
#pre-offers-container .selected_radio_text {
  color: white;
}
#pre-offers-container .list_label{
  color: #666;
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px; /* 118.75% */
}
#need_other_amount_container .small-input{
  width: 80%;
  margin: 0 auto;
}
/* end custom styles */
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#continue-prequalified-container{
  padding-left: 10px;
}
#continue-prequalified-button{
  /* width: 300px; */
  margin-top: 30px;
  background-color: black;

  color: #FFF;
  text-align: center;
  /* leading-trim: both; */
  /* text-edge: cap; */
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.ccc {
  background-color: #ccc;
}
#file-input {
  height: 100%;
  width: 100%;
  background-color: #dbe9ff;
  opacity: 0;
  /* padding: 10px; */
  position: absolute;
  top: 0px;
  left: 0px;
  cursor: pointer;
}
.file_entry_name {
  margin-bottom: 0px;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
#filebox {
  line-height: 3;
  border-radius: 5px;
  position: relative;
  transition: all 0.5s;
  cursor: pointer;
  font-size: 16px;
  height: 40px;
  color: #3a67d2;
  text-decoration: underline;
}
#filebox:hover {
  cursor: pointer;
}
#filecounter {
  font-weight: bold;
  text-align: center;
  font-variant-caps: all-petite-caps;
  background: #fcfdff;
  padding: 5px;
}
.file-entry {
  padding: 8px;
  background: #e6eefb87;
  border-radius: 5px;
  margin-bottom: 10px;
  display: flex;
  align-content: center;
  align-items: center;
  border: 2px solid #5972aa;
}
.entry-info {
  text-align: right;
  padding: 5px;
}
.entry-input {
  flex-grow: 1;
  flex-basis: "auto";
}
.faded {
  opacity: 0.3;
}
/* start new design */
#success_container {
  margin-top: 64px !important;
  height: 70vh;
}
sup {
  font-size: 50%;
}
#advantages_title {
  font-size: 36px;
  font-weight: bold;
  font: normal normal bold 32px/30px Roboto;
  letter-spacing: 0px;
  color: #000000;
  text-align: left;
}
.advantages_item {
  font: normal normal normal 20px/24px Roboto;
  letter-spacing: 0px;
  color: #000000;
  text-align: left;
  /* margin-left: 5%;
  margin-right: 5%; */
}
.advantage_separator {
  border-top: 1px solid #ccc;
  padding-bottom: 10px;
  padding-top: 5px;
}

.iphone_plaid_mobile {
  display: none;
}
#shield {
  max-width: 300px;
  margin: auto;
  display: block;
}
#main_container {
  display: flex;
}
#image_title_container {
  background-size: contain;
  margin-left: 5%;
}
#image_container_desktop {
  margin-top: 17px;
}
#logo {
  padding-top: 64px;
  width: 681px;
}
#iphone_plaid {
  margin-bottom: 32px;
}
.notes {
  text-align: left;
  font: normal normal normal 16px/19px Roboto;
  letter-spacing: 0px;
  color: #666666;
  opacity: 1;
  margin-right: 8%;
}
.pure-button {
  border-radius: 24px;
  /* border: 2px solid transparent; */
  font-family: Roboto;
  font-size: 16px;
  /* font-weight: 500; */
  font-weight: 900;
  opacity: 1;
  text-align: center;
  font: normal normal 900 16px/40px Roboto;
  letter-spacing: 0.8px;
  color: #ffffff;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 20px;
  padding-right: 20px;
  letter-spacing: 0.9px;
  /* mobile */
  height: 46px;
  width: 240px;
}
.btn-success {
  background: #28a745 0% 0% no-repeat padding-box;
  color: #ffffff !important;
}
#lets_try {
  font: normal normal bold 32px/24px Roboto;
  letter-spacing: 0px;
  color: #000000;
  margin-bottom: 32px;
}
@media (max-width: 80em) {
}
@media (max-width: 47.999em) {
  .done_adding_files_container {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  #success_container {
    margin-top: 64px !important;
    height: auto;
  }
  #image_title_container {
    text-align: center;
    margin-top: -38px;
    padding-top: 48px;
    padding-top: 80px;
    max-height: none;
    background-repeat: no-repeat;
    margin-left: 0;
    background-size: contain;
  }

  .notes {
    /* margin-left: 32px; */
    margin-left: 8%;
  }
  #main_container {
    display: block;
    padding-top: 14px;
  }
  #image_container_desktop {
    display: none;
  }
  .iphone_plaid_mobile {
    display: block;
    margin: 0 auto;
  }
  #logo {
    width: 90%;
    width: 340px;
    height: 208px;
    padding-top: 0;
    display: unset !important;
  }
  .bank_icon {
    display: unset !important;
  }
  #advantages_title {
    font-size: 24px;
    margin-left: 8%;
    margin-right: 8%;
  }
  .advantages_item {
    font-size: 16px;
    margin-left: 8%;
    margin-right: 8%;
  }
  .advantage_separator {
    margin-left: 8%;
    margin-right: 8%;
  }
  .pure-button {
    margin: 0 auto;
  }
}
/* new design */
#pre-qualify-label{
  color: #666;
  text-align: center;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px; /* 95% */
}
#pre-offers-container{
  width: 100%;
  max-width: 360px;
  border-radius: 8px;
  border: 1px solid #CCC;
  background: #F6F6F6;
  padding-left: 20px;
  padding-right: 20px;
  min-height: 520px;
  margin-top: 47px;
}
#congratulations-title{
  color: #000;
  text-align: center;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 20px;
}
#speak-representative-container{
  margin-top: 30px;
}
#gif-container{
  flex-shrink: 0;
  text-align: center;
  position: relative;
  top: -45px;
}
#circle-container{
    width: 81px; /* Set the width of the div */
    height: 81px; /* Set the height of the div (same as width for a perfect circle) */
    border: 3px solid #3A67D2;; /* Set the border thickness and color */
    border-radius: 50%; /* Make the div a circle */
    display: flex; /* Flexbox for centering content */
    justify-content: center; /* Center content horizontally */
    align-items: center; /* Center content vertically */
    text-align: center; /* Align text if multiline */
    background-color: #f9f9f9; /* Optional background color */
    color: #333; /* Optional text color */
    font-size: 16px; /* Optional font size */
    display: inline-flex;
}
#error_display{
  display: none;
  text-align: center;
  color: red;
  margin-top: 10px;
}


</style>